import { faCircleInfo } from '@hg-akademie-ban/ban-elevate-assets/icons/regular';
import { Typography } from '@mui/material';

import { Icon } from '@/components/ui/icon.js';
import { Tooltip } from '@/components/ui/tooltip.js';
export const ManuellerAusschreibungsprozessInfo = () => (
  <div className="absolute top-24 right-24">
    <Tooltip
      trigger={
        <div className="flex items-center">
          <Icon
            icon={faCircleInfo}
            size="small"
            className="text-feedback-info"
            style={{ color: 'var(--ld-color-content-feedback-info)' }}
          />
        </div>
      }
      headline="Info"
      className="z-1600 max-w-md"
      onDismiss={() => void 0}
    >
      <Typography variant="inherit" sx={{ color: 'inherit' }}>
        Hier findest du alle Ausschreibungen/Angebote, die zu dieser AKA-Veranstaltungs-ID im Ausschreibungsportal
        gefunden wurden. Diese Liste kann unvollständig sein.
      </Typography>
    </Tooltip>
  </div>
);
